import React from 'react';
var css = {
  "cardContainer": "rui-XBbpI",
  "image": "rui-bl7bw",
  "headerContainer": "rui-0Usrp",
  "body": "rui-BKuzr",
  "footer": "rui-LqHiD",
  "footerText": "rui-kNTY4",
  "footerAside": "rui-o3eLO",
  "iconContainer": "rui-OhrTE"
};
import Icon from '../Icon/Icon';
import Heading from '../Heading/Heading';
var CardCarousel = function CardCarousel(_ref) {
  var _ref$image = _ref.image,
    image = _ref$image === void 0 ? '' : _ref$image,
    _ref$imageAlt = _ref.imageAlt,
    imageAlt = _ref$imageAlt === void 0 ? '' : _ref$imageAlt,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? '' : _ref$icon,
    _ref$onIconClick = _ref.onIconClick,
    onIconClick = _ref$onIconClick === void 0 ? function () {} : _ref$onIconClick,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? '' : _ref$iconColor,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? '' : _ref$subtitle,
    _ref$body = _ref.body,
    body = _ref$body === void 0 ? '' : _ref$body,
    _ref$footer = _ref.footer,
    footer = _ref$footer === void 0 ? '' : _ref$footer,
    _ref$aside = _ref.aside,
    aside = _ref$aside === void 0 ? '' : _ref$aside;
  return /*#__PURE__*/React.createElement("div", {
    className: css.cardContainer
  }, image && /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: imageAlt,
    className: css.image
  }), title && /*#__PURE__*/React.createElement("div", {
    className: css.headerContainer
  }, /*#__PURE__*/React.createElement(Heading, {
    color: "blackText",
    tag: "div",
    type: "subtitle"
  }, title), icon && /*#__PURE__*/React.createElement("div", {
    onClick: onIconClick,
    className: css.iconContainer,
    onKeyPress: onIconClick,
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    size: 20,
    color: iconColor
  }))), subtitle && /*#__PURE__*/React.createElement(Heading, {
    fontWeight: "normal",
    color: "blackText",
    tag: "div",
    type: "body1"
  }, subtitle), body && /*#__PURE__*/React.createElement("div", {
    className: css.body
  }, body), /*#__PURE__*/React.createElement("div", {
    className: css.footer
  }, /*#__PURE__*/React.createElement("div", {
    className: css.footerText
  }, footer), aside && /*#__PURE__*/React.createElement("div", {
    className: css.footerAside
  }, aside)));
};
export default CardCarousel;